import React__default from 'react';
import { Image } from '@deal/components';
import styles from './styles.css.js';

var HeroWithImage = function HeroWithImage(_a) {
  var imageUrl = _a.imageUrl,
      heroLabel = _a.heroLabel;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: styles.hero
  }, imageUrl && React__default.createElement(Image, {
    src: imageUrl,
    width: 384,
    height: 134,
    imgixParams: {
      fit: 'crop'
    },
    className: styles.heroImage
  }), heroLabel && React__default.createElement("div", {
    className: styles.overlay
  }, heroLabel)));
};

export default HeroWithImage;
//# sourceMappingURL=index.js.map
